import { AssetSchemaRaw, SystemTypeRaw } from '@innovyze/lib_asset_schema';
import { createAction } from 'redux-actions';
import { addNamespace } from './utils';

/**
 * Action to get asset schema.
 * @param assetDetails - The details of the asset including system type and asset type.
 */
export const getAssetSchemaAction = createAction(
	addNamespace('assetSchema/getAssetSchema'),
	(assetDetails: { systemType?: string; assetType: string }) => assetDetails,
);

/**
 * Action dispatched when asset schema is successfully retrieved.
 * @internal
 */
export const getAssetSchemaResolved = createAction<
	[SystemTypeRaw, AssetSchemaRaw]
>(addNamespace('assetSchema/getAssetSchema/resolved'));

/**
 * Action dispatched when there is an error retrieving the asset schema.
 * @internal
 */
export const getAssetSchemaRejected = createAction(
	addNamespace('assetSchema/getAssetSchema/rejected'),
);

/**
 * Action to get asset schema by system type.
 * @param systemType - The type of the system.
 */
export const getAssetSchemaBySystemTypeAction = createAction(
	addNamespace('assetSchema/getAssetSchemaBySystemType'),
	(systemType: string) => systemType,
);

/**
 * Action dispatched when asset schema by system type is successfully retrieved.
 * @internal
 */
export const getAssetSchemaBySystemTypeResolved = createAction<
	[SystemTypeRaw, AssetSchemaRaw][]
>(addNamespace('assetSchema/getAssetSchemaBySystemType/resolved'));

/**
 * Action dispatched when there is an error retrieving the asset schema by system type.
 * @internal
 */
export const getAssetSchemaBySystemTypeRejected = createAction(
	addNamespace('assetSchema/getAssetSchemaBySystemType/rejected'),
);

/**
 * Action to get all assets schema.
 */
export const getAllAssetsSchemaAction = createAction(
	addNamespace('assetSchema/getAllAssetsSchema'),
);

/**
 * Action dispatched when all assets schema are successfully retrieved.
 * @internal
 */
export const getAllAssetsSchemaResolved = createAction<
	[SystemTypeRaw, AssetSchemaRaw][]
>(addNamespace('assetSchema/getAllAssetsSchema/resolved'));

/**
 * Action dispatched when there is an error retrieving all assets schema.
 * @internal
 */
export const getAllAssetsSchemaRejected = createAction(
	addNamespace('assetSchema/getAllAssetsSchema/rejected'),
);
